import { stringField } from 'common/utils/form/fieldTypes';

export default {
  name: stringField({ required: true }),
  details: stringField({ required: true })
};
